<template>
    <div>
        <md-dialog-confirm
        :md-active.sync="showDialog"
            md-title="Aviso"
            md-content="Desea guardar su información."
            md-confirm-text="Si"
            md-cancel-text="No"
            @md-cancel="onCancel"
            @md-confirm="onConfirm" />

        <div class="md-layout">
            <div class="logo" :class="{ 'bordershow': !borderShow }">
                <img src="@/assets/faro2.png" width="179"/>
            </div>  
        </div>
        <div class="md-layout int">
            <div class="md-layout-item">
                <div v-for="(value, index) in history" v-bind:key="index" :id="value.id">
                    <component v-if="value.show == true" :is="index" 
                    @setDone="setDoneRoot" 
                    @setBack="setBackRoot" 
                    @setSaveForm="setSaveFormRoot"
                    :complete="complete"
                    :pais="pais"
                    :isDisabled="isDisabled"/>
                </div>
            
            </div>
            
        </div>  
        
    </div>    
</template>

<script>
import {
    Form0,
    Form1,
    Form2,
    Form21,
    Form22,
    Form23,
    Form3,
    Form4,
    Form5,
    Form7,
    Form8,
    Form9,
    Form10
} from "./index";
import eventBus from '../bus'
import pais from '../json/pais.json'

export default {
    name:"Home",
    data: () => ({  
      active: '0',
      preview: null,
      enviar:false,
      history:{},
      traceName:[],
      complete:0,
      pais: [],
      borderShow: true,
      lastScrollPosition: 0,
      showDialog:false,
      dataTemp:null,
      isDisabled: true
    }),
    async mounted (){
        await this.Init()
    }, 
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods:{
        async Init(){
            this.history = this.$store.state.history
            this.traceName = this.$store.state.traceName
            this.preview = this.active
            this.$store.dispatch("tipo", {tipo:"S", active: this.active});
            eventBus.$emit('isLoading', true);

            var that = this
            that.pais = pais;
            window.addEventListener('scroll', this.onScroll)   

            await this.$store.dispatch("loadPais").then((response)=>{
                that.pais = response.data.data
            })
            .catch(()=>{
                that.$router.push({name:"Error"})
            });

            await this.$store.dispatch("loadFormulario", this.$route.params.id.toString())
            .then((response)=>{
                //that.$store.dispatch("loadFondos")
                if(typeof(that.$route.params.view) === 'undefined'){
                    that.active = response.active
                }else{
                    if(that.$route.params.view == "promotor"){

                        that.trace =JSON.parse(response.trace)
                        that.active = that.trace[0].toString();
                        
                    }else{
                    that.active = response.active 
                    }
                }
                
                that.complete = response.complete
                eventBus.$emit('isLoading', false);
                this.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                this.$router.push({name:"NotFound"})
                this.activeComponent()
            });
        },

        updateFormulario(p){
            this.$store.dispatch("formUpdate", {
                form:p, 
                ide: this.$route.params.id.toString(), 
                complete: 2
            });
        },

        scrollTop(){
            window.scrollTo(0, 0);            
        }, 

        onScroll () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return
            }
            this.borderShow = currentScrollPosition < this.lastScrollPosition
            this.lastScrollPosition = currentScrollPosition
        },

        setDoneRoot(p){
            this.setDoneForm(p)
            this.activeComponent()
        },        
        setDoneForm(p){
            this.preview = p.id;
            
            this.history["form"+p.id].enviado = true

            if (p.index) {
                this.active = p.index
            }
            this.$store.dispatch("tipo", {tipo:"S", active: this.active});

            this.scrollTop()
        },
        setBackRoot(p){

            var form = p.id.toLowerCase();

            const findActive = (element) => element == this.active;
            const index = this.trace.findIndex(findActive)
            var pre = "0"

            if(index > 0){
                pre = this.trace[index - 1]
            }
            this.preview = pre
            var x = this.preview;

            this.history[form].enviado = false
            this.history[form].show = false;

            this.active = x;
            eventBus.$emit('isLoading', true);
            this.activeComponent()
            this.scrollTop()
            eventBus.$emit('isLoading', false);

        },              
        setSaveFormRoot(p){
            this.active = p.index;
            this.preview = p.id
            eventBus.$emit('isLoading', true);
            this.activeComponent()
            this.updateFormulario(p)
            this.scrollTop()
            eventBus.$emit('isLoading', false);
        },   
        activeComponent(){
            this.inactiveComponent()
            this.history["form"+this.preview].show = false;
            this.history["form"+this.active].show = true;
            //this.traceName = this.$store.state.traceName; 
        },
        inactiveComponent(){
            this.$store.dispatch("hideAllComponent");
        },
        onConfirm () {
            this.value = 'Agreed'
            var that = this;

            that.updateFormulario(that.dataTemp);

            return this.$store.dispatch("saveFormulario", {
                form:null, 
                ide: this.$route.params.id.toString(), 
                complete: 2,
                user:this.$route.params.pro.toString()
            })            
            .then(() =>{
                
                this.next();
                this.scrollTop()
                eventBus.$emit('isLoading', false);
                that.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                that.$router.push({name:"Error"})
            })
        },
        next(){
            const findActive = (element) => element == this.active;
            const index = this.trace.findIndex(findActive)
            var pre = this.trace[index + 1]
            if(typeof(pre)==="undefined"){
                pre = "30"
            }
            this.setDoneForm({id: this.active, index: pre})
            
        },
        onCancel () {
            this.value = 'Disagreed'
            eventBus.$emit('buttonDisabled', true);
        },
        saveInfo(){
            this.showDialog = true
        }   

    },
    created(){
        var that = this
        eventBus.$on('saveandContinous',(data)=>{
            that.dataTemp = data
            eventBus.$emit('buttonDisabled', true);
            that.saveInfo()
        })
    },
    computed:{
        elementStepper: function(){
            if(this.traceName.length == 0){
                return false
            }
            return true
        }
    },
    async beforeRouteUpdate(to, from, next) {
        await window.location.reload()
        await next()
    }, 
    components:{    
        Form0,
        Form1,
        Form2,
        Form21,
        Form22,
        Form23,
        Form3,
        Form4,
        Form5,
        Form7,
        Form8,
        Form9,
        Form10
    }
}
</script>

<style>

</style>